export default "__VITE_ASSET__QMcnVSTe__"